var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRandom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6954 0 0 2.6954 56.374 15.136)",
    fillRule: "evenodd",
    fontSize: "12px",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: ".5mm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.7 53.4h-12.8v-21.1h7.6a19.614 19.614 0 0 0 2.392-0.136q1.221-0.151 2.236-0.467a8.46 8.46 0 0 0 1.822-0.797 4.385 4.385 0 0 0 1.867-2.308q0.483-1.279 0.483-3.092v-2.3q0-2.87-1.261-4.596a5.402 5.402 0 0 0-1.439-1.354 9.418 9.418 0 0 0-2.46-1.1q-2.193-0.65-5.24-0.65-4.1 0-8 0.85a66.926 66.926 0 0 0-7.4 2.078 73.451 73.451 0 0 0-0.5 0.172v-12.7a32.558 32.558 0 0 1 4.03-2.205q2.279-1.056 4.97-1.945a33.487 33.487 0 0 1 6.059-1.362 46.274 46.274 0 0 1 6.141-0.388 34.036 34.036 0 0 1 5.345 0.397q2.916 0.464 5.342 1.472a19.152 19.152 0 0 1 1.563 0.731 18.47 18.47 0 0 1 5.41 4.213 17.318 17.318 0 0 1 2.09 2.987q2.55 4.6 2.55 10.6v5.4a28.252 28.252 0 0 1-0.523 5.619q-0.677 3.332-2.228 5.882a14.834 14.834 0 0 1-2.349 2.949 15.683 15.683 0 0 1-5.751 3.47q-2.461 0.878-5.5 1.235a38.149 38.149 0 0 1-4.449 0.245zm-1.4 20.7h-10.1a3.167 3.167 0 0 1-0.871-0.109q-0.976-0.279-1.235-1.276a3.241 3.241 0 0 1-0.094-0.815v-11q0-2.3 2.2-2.3h10.1a3.311 3.311 0 0 1 0.91 0.114q1.39 0.398 1.39 2.186v11a3.47 3.47 0 0 1-0.051 0.616q-0.131 0.724-0.599 1.084-0.65 0.5-1.65 0.5z",
    vectorEffect: "non-scaling-stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom);
export default __webpack_public_path__ + "static/media/random.9c974a4cce14fa7d2e9c482bcb4da5c6.svg";
export { ForwardRef as ReactComponent };